module.exports = "/packs/images/mission-values/mission-hero@2x-590fc3ddc35811891fd44386e31cf999.jpg";


//////////////////
// WEBPACK FOOTER
// ./app/javascript/images/mission-values/mission-hero@2x.jpg
// module id = 1777
// module chunks = 0